import { useState, useEffect } from 'react';

/**
 * Hook personalizado para detectar si es la primera vez que el usuario visita la aplicación
 * @param {string|null|undefined} key - Clave en localStorage. Si es null/undefined/vacía, no hay “primera visita” hasta definir clave.
 * @returns {[boolean, function]} - Retorna [isFirstVisit, markAsVisited]
 */
const useFirstVisit = (key = 'hasVisitedFengCart') => {
  const resolvedKey =
    typeof key === 'string' && key.length > 0 ? key : null;

  const [isFirstVisit, setIsFirstVisit] = useState(false);

  useEffect(() => {
    if (!resolvedKey) {
      setIsFirstVisit(false);
      return;
    }
    const hasVisited = localStorage.getItem(resolvedKey);
    setIsFirstVisit(!hasVisited);
  }, [resolvedKey]);

  const markAsVisited = () => {
    if (!resolvedKey) {
      return;
    }
    localStorage.setItem(resolvedKey, 'true');
    setIsFirstVisit(false);
  };

  return [isFirstVisit, markAsVisited];
};

export default useFirstVisit;

